export class Analytics {
  capture(eventName, properties) {
    throw new Error('capture() must be implemented by analytics provider')
  }
}
